<template>
  <div class="container coupon">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>
        <el-breadcrumb-item>优惠券列表</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">优惠券包</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleCouponCreate"
          >添加优惠券</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="优惠券名称"
          prop="name"
        >
          <el-input
            v-model="query.name"
            placeholder="输入优惠券名称"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">优惠券列表</h3>
        <el-form
          size="small"
          :inline="true"
        >
          <el-form-item>
            <el-radio-group
              v-model="query.status"
              @change="fetchCouponList(true)"
            >
              <el-radio-button
                v-for="(item, index) in filter.status"
                :key="index"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="优惠券名称"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="description"
            label="优惠券简介"
            width="200"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="使用门槛"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.min_cost">订单满{{ scope.row.min_cost }}元可用</span>
              <span v-else>无使用门槛</span>
            </template>
          </el-table-column>
          <el-table-column
            label="优惠内容"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.discount_amount">减免{{ scope.row.discount_amount }}元</span>
              <span v-else>打{{ scope.row.discount_rate }}折</span>
            </template>
          </el-table-column>
          <el-table-column
            label="适用商品"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.ref_ids">包含{{ scope.row.ref_ids.split(",").length }}份商品</span>
              <span v-else-if="scope.row.ref_group_ids">包含{{
                  scope.row.ref_group_ids.split(",").length
                }}个商品组</span>
              <span v-else>全部商品可用</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="circulation"
            label="发放总量"
            min-width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="receive_count"
            label="已领取"
            min-width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="used_count"
            label="已使用"
            min-width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="有效期"
            min-width="300"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.start_time).format("YYYY.MM.DD HH:mm:ss") }} -
                {{ $moment(scope.row.end_time).format("YYYY.MM.DD HH:mm:ss") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sort"
            label="排序值"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="creator"
            label="创建人"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'">{{
                scope.row.status == 1 ? "正常" : "下线"
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180"
            align="center"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToCouponEdit(scope.row, scope.$index)"
              >编辑</el-button>
              <el-button
                size="mini"
                type="text"
                :disabled="scope.row.status != 1"
                @click="handleToCouponShare(scope.row, scope.$index)"
              >推广</el-button>
              <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                @click="handleToAdRemove(scope.row, scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToCouponEdit(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToCouponShare(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      推广
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToAdRemove(scope.row, scope.$index)"
                      style="font-size:16px;color:#F56C6C;"
                    >
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 推广弹窗 -->
    <CouponExtension
      :isVisible="CouponExtensionDialog"
      :content="CouponExtensionContent"
      @close="CouponExtensionDialog=false"
    />
  </div>
</template>

<script>
import { couponList, couponDestroy } from "@/api/operation";
import CouponExtension from "../../../components/dialog/coupon/CouponExtension.vue";

export default {
  components: {
    CouponExtension
  },
  data() {
    return {
      editRow: {
        ref_content: {},
      },
      query: {
        name: "",
        status: "1",
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      filter: {
        status: [
          { label: "全部", value: "" },
          { label: "进行中", value: "1" },
          { label: "已结束", value: "0" },
        ],
        types: [
          { label: "全部", value: "" },
          { label: "统考", value: "1" },
          { label: "非统考", value: "0" },
        ],
      },
      results: [],
      CouponExtensionDialog: false,
      CouponExtensionContent: {},
      isfixed: document.body.clientWidth < 820 ? false : true,
    };
  },
  created() {
    this.parseQuery();
    this.fetchCouponList();
    this.$store.dispatch('getAdminList')
  },
  methods: {
    // 优惠券列表请求
    fetchCouponList(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      couponList(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchCouponList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchCouponList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchCouponList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchCouponList();
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        1: "正常",
        2: "关闭",
      };
      if (type == "status") {
        return status[value] || "";
      }
      return "";
    },
    // 优惠券创建
    handleCouponCreate() {
      this.$router.push(`/coupon/create`);
    },
    // 优惠券编辑
    handleToCouponEdit(row) {
      this.$router.push(`/coupon/edit/${row.id}`);
    },
    // 优惠券分享
    handleToCouponShare(row) {
      this.CouponExtensionContent = JSON.parse(JSON.stringify(row))
      this.CouponExtensionDialog = !this.CouponExtensionDialog
      /*    window.open(
           `https://h5.kaoyanbox.com/activity/coupon?couponId=${row.id}`
         ); */
    },
    // 优惠券删除
    handleToAdRemove(row) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          couponDestroy({ id: row.id }).then((res) => {
            this.$message.success(`删除成功`);
            this.fetchCouponList();
          });
        })
        .catch(() => { });
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (this.$store.state.adminList.findIndex((v) => { return v.id == val }) > -1) {
            return this.$store.state.adminList.find((v) => { return v.id == val }).nickname
          } else {
            return "无"
          }
        } else {
          return "无"
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.coupon {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    width: 100.5%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
